import { REQUEST_MEDIA, RECIEVE_MEDIA, REQUEST_MEDIA_SEARCH, RECEIVE_MEDIA_SEARCH } from '../constants/actionTypes';
import { getBody, displayError } from './helpers';
import { getBackendUrl } from '../env';


// Action Creators
const requestMedia = scene => ({
    type: REQUEST_MEDIA,
    scene: scene
});

const recieveMedia = (scene, mediaItems) => ({
    type: RECIEVE_MEDIA,
    scene: scene,
    mediaItems: mediaItems
});

const cleanupRecieveMedia = scene => ({
    type: RECIEVE_MEDIA,
    scene: scene,
    cleanup: true
});

// Action Logic
const shouldFetchMedia = (scene, force, state) => {
    // Do not fetch if scene is empty or undefined for some reason
    if (!scene) {
        return false;
    }

    // If we already have this scene in our state, then additional checks are needed.
    // Do not fetch them if we have already asked for them, or if there is no media in the scene.
    // If force is true, ignore the media already existing.
    if (scene in state.mediaByScene) {
        const {mediaItems, fetchingMedia} = state.mediaByScene[scene];

        if (fetchingMedia || (mediaItems && !force)) {
            return false;
        }        
    } 

    return true;
};

const fetchMedia = scene => (dispatch) => {
    dispatch(requestMedia(scene));
    return fetch(`${getBackendUrl()}/api/v1/scene/${scene}`)
        .then(getBody)
        .then(json => dispatch(recieveMedia(scene, json.media)));
};

export const fetchMediaIfOK = (scene, force) => (dispatch, getState) => {
    if (shouldFetchMedia(scene, force, getState())) {
        return dispatch(fetchMedia(scene))
            .catch(err => {
                dispatch(cleanupRecieveMedia);
                dispatch(displayError(err));
            }
        );
    }
};

//Search Media
const requestMediaSearch = ({
    type: REQUEST_MEDIA_SEARCH
});

const receiveMediaSearch = json => ({
    type: RECEIVE_MEDIA_SEARCH,
    mediaSearchResult: json
});

export const getSearchedMedia = (mediaName) => dispatch => {
    dispatch(requestMediaSearch);

    return fetch('http://localhost:8082/mediasource?sourcePath='+ mediaName +'&rowLimit=200', {
        method: 'GET'
    })
        .then(getBody)
        .then(json => {
            dispatch(receiveMediaSearch(json));
        })
        .catch(err => {
            dispatch(displayError(err));
        });
};



// WEBPACK FOOTER //
// ./src/actions/fetchMedia.js